// Mock properties for pre-qualification form
export const properties = [
  {
    id: '1',
    name: 'Parker Terrace Duplexes'
  },
  {
    id: '2',
    name: 'Newton St Duplexes'
  },
  {
    id: '3',
    name: 'Archie St Apartments'
  },
  {
    id: '4',
    name: 'Sheridan Dr Duplexes'
  },
  {
    id: '5',
    name: 'Other'
  }
];